import { useState } from 'react';

export default function SaveConfigModal({ onClose, onSave, loading, defaultName }) {
    const [name, setName] = useState(defaultName || '');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) {
            setError('نام برنامه الزامی است.');
            return;
        }
        try {
            await onSave({ name: name.trim(), description: description.trim() || null });
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="admin-modal-backdrop" onClick={onClose}>
            <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
                <div className="admin-modal-header">
                    <h3 className="admin-modal-title">💾 ذخیره برنامه پورسانت</h3>
                    <button className="admin-modal-close" onClick={onClose}>✕</button>
                </div>

                <form onSubmit={handleSubmit} className="admin-modal-body">
                    {error && <div className="error-banner">{error}</div>}

                    <label className="form-field">
                        <span>نام برنامه *</span>
                        <input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="مثلاً: برنامه پاییزه"
                            required
                        />
                    </label>

                    <label className="form-field">
                        <span>توضیحات (اختیاری)</span>
                        <input
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="توضیح کوتاه"
                        />
                    </label>

                    <div className="admin-modal-footer">
                        <button type="button" onClick={onClose} className="btn btn-ghost">
                            انصراف
                        </button>
                        <button type="submit" disabled={loading} className="btn btn-primary">
                            {loading ? 'در حال ذخیره...' : 'ذخیره'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}